import React, {useEffect} from 'react';

import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Column,
  Form,
  Grid,
  PasswordInput,
  TextArea,
  TextInput,
  Tile
} from '@carbon/react';
import {ADD, useToastContext} from "../../components/Toast"
import './_userprofile.scss'
import {Link} from "react-router-dom";
import {grpcUserServiceSelector} from "../../state/grpc";
import {useRecoilState, useRecoilValue} from "recoil";
import {userProfileFormState} from "../../state/user_profile";

const UserProfile = () => {
  const usersService = useRecoilValue(grpcUserServiceSelector)
  const [{
    id,
    company,
    firstName,
    lastName,
    username,
    email,
    address,
    city,
    country,
    zipCode,
    biography,
    image,
    loading,
    saving,
    error
  }, setUserProfileForm] = useRecoilState(userProfileFormState);
  const {toastDispatch} = useToastContext();

  useEffect(() => {
    const req = new proto.api.GetUserRequest()
    usersService.getUser(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        setUserProfileForm({loading: false, saving: false, error: err})
      } else {
        const user = resp.toObject().user
        setUserProfileForm({
          id: user.id,
          company: user.company,
          firstName: user.firstname,
          lastName: user.lastname,
          username: user.username,
          email: user.email,
          address: user.address,
          city: user.city,
          country: user.country,
          zipCode: user.zipCode,
          biography: user.biography,
          image: user.imageindex,
          loading: false,
          saving: false,
          err: ''
        })
      }
    })
  }, [])

  const onSubmit = (ev) => {
    ev.stopPropagation()
    const req = new proto.api.SaveUserRequest()
    let user = new proto.api.User()
    user.setId(id)
    user.setCompany(company)
    user.setFirstname(firstName)
    user.setLastname(lastName)
    user.setUsername(username)
    user.setEmail(email)
    user.setAddress(address)
    user.setCity(city)
    user.setCountry(country)
    user.setZipCode(zipCode)
    user.setBiography(biography)
    user.setImageindex(image)
    req.setUser(user)
    setUserProfileForm({
      id,
      company,
      firstName,
      lastName,
      username,
      email,
      address,
      city,
      country,
      zipCode,
      biography,
      image,
      loading,
      saving: true,
      error: ''
    })
    usersService.updateUser(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        setUserProfileForm({
          id,
          company,
          firstName,
          lastName,
          username,
          email,
          address,
          city,
          country,
          zipCode,
          biography,
          image,
          loading,
          saving: false,
          error: err
        })
        toastDispatch({
          type: ADD,
          payload: {
            title: "Operazione fallita",
            content: "Errore durante il salvataggio del profilo",
            kind: "error",
            caption: err.message
          }
        })
      } else if (resp != null && resp.array.length > 0) {
        setUserProfileForm({
          id,
          company,
          firstName,
          lastName,
          username,
          email,
          address,
          city,
          country,
          zipCode,
          biography,
          image,
          loading,
          saving: false,
          error: ''
        })
        toastDispatch({
          type: ADD,
          payload: {
            title: "Operazione avvenuta con successo",
            content: "Profilo salvato con successo",
            kind: "success"
          }
        })
      }
    })
  }

  const changeUserImage = () => {
    let newImg = image
    if (image < 16) {
      newImg = image + 1
    } else {
      newImg = 1
    }
    setUserProfileForm({
      id,
      company,
      firstName,
      lastName,
      username,
      email,
      address,
      city,
      country,
      zipCode,
      biography,
      image: newImg,
      loading,
      saving,
      error,
    })
  }

  const handleChangePassword = (ev) => {
    ev.stopPropagation()
    const oldPwd = document.getElementById("old-password").value
    const newPwd = document.getElementById("new-password").value
    const newPwdConfirm = document.getElementById("new-password-confirm").value
    const btn = document.getElementById("change-password-btn")
    if (newPwd !== newPwdConfirm) {
      alert("Le password non coincidono")
      return
    }
    btn.textContent = "Operazione in corso.."
    btn.disabled = true
    const req = new proto.api.ChangePasswordRequest()
    req.setOldpassword(oldPwd)
    req.setNewpassword(newPwd)
    usersService.changePassword(req, null, (err, resp) => {
      if (err != null) {
        console.log(err)
        toastDispatch({
          type: ADD,
          payload: {
            title: "Operazione fallita",
            content: "Non è stato possibile modificare la password",
            kind: "error",
            caption: err.message
          }
        })
      } else {
        toastDispatch({
          type: ADD,
          payload: {
            title: "Operazione avvenuta con successo",
            content: "Password modificata con successo",
            kind: "success"
          }
        })
      }
      btn.textContent = "Cambia password"
      btn.disabled = false
      ev.target.reset()
    })
  }

  return (
    <Grid fullWidth className="userprofile-page">
      <Column lg={16} md={8} sm={4}>
        <Grid className="page-banner">
          <Column lg={16} md={4} sm={4}>
            <Breadcrumb noTrailingSlash aria-label="Page navigation">
              <BreadcrumbItem>
                <Link to='/'>Home</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                Profilo
              </BreadcrumbItem>
            </Breadcrumb>
          </Column>
          <Column lg={16} md={4} sm={4}>
            <h1 className="page-heading">
              Utente <span style={{fontWeight: 'bold'}}>{username}</span>
            </h1>
          </Column>
        </Grid>
        <Form onSubmit={(ev) => onSubmit(ev)}>
          <Grid>
            <Column lg={3} md={4} sm={4} style={{textAlign: 'center'}}>
              <Tile className="userprofile-page__card">
                <img
                  src={`avatars/${image}.png`}
                  alt="User"
                  className="userprofile-page__image"
                  title="Cambia immagine"
                  onClick={() => {
                    if (confirm("Sei sicuro di voler cambiare immagine profilo?")) {
                      changeUserImage()
                    }
                  }}
                />
                <br/>
                <span className="userprofile-page__fullnameUnderPic">{firstName} {lastName}</span><br/>
                <span className="userprofile-page__usernameUnderPic">@{username}</span>
              </Tile>
            </Column>
            <Column lg={13} md={4} sm={4}>
              <Tile className="userprofile-page__card">
                <Grid className="userprofile_page__fields">
                  <Column lg={16} md={4} sm={4}>
                    <h4 className="userprofile_page__section-title">
                      Dati utente
                    </h4>
                    <Grid className="userprofile_page__form_row">
                      <Column lg={3} md={4} sm={4}>
                        <TextInput
                          id="username"
                          disabled
                          labelText="Username (Non modificabile)"
                          value={username}
                          onChange={ev => setUserProfileForm({
                            id,
                            company,
                            firstName,
                            lastName,
                            username: ev.target.value,
                            email,
                            address,
                            city,
                            country,
                            zipCode,
                            biography,
                            loading,
                            saving,
                            error: ''
                          })}
                        />
                      </Column>
                      <Column lg={8} md={4} sm={4}>
                        <TextInput
                          id="company"
                          labelText="Azienda"
                          value={company ? company : ""}
                          onChange={ev => setUserProfileForm({
                            id,
                            company: ev.target.value,
                            firstName,
                            lastName,
                            username,
                            email,
                            address,
                            city,
                            country,
                            zipCode,
                            biography,
                            loading,
                            saving,
                            error: ''
                          })}
                        />
                      </Column>
                      <Column lg={5} md={4} sm={4}>
                        <TextInput
                          id="email"
                          labelText="Indirizzo Email"
                          value={email}
                          onChange={ev => setUserProfileForm({
                            id,
                            company,
                            firstName,
                            lastName,
                            username,
                            email: ev.target.value,
                            address,
                            city,
                            country,
                            zipCode,
                            biography,
                            loading,
                            saving,
                            error: ''
                          })}
                        />
                      </Column>
                    </Grid>
                    <Grid className="userprofile_page__form_row">
                      <Column lg={8} md={4} sm={4}>
                        <TextInput
                          id="firstname"
                          labelText="Nome"
                          value={firstName ? firstName : ""}
                          onChange={ev => setUserProfileForm({
                            id,
                            company,
                            firstName: ev.target.value,
                            lastName,
                            username,
                            email,
                            address,
                            city,
                            country,
                            zipCode,
                            biography,
                            loading,
                            saving,
                            error: ''
                          })}
                        />
                      </Column>
                      <Column lg={8} md={4} sm={4}>
                        <TextInput
                          id="lastname"
                          labelText="Cognome"
                          value={lastName ? lastName : ""}
                          onChange={ev => setUserProfileForm({
                            id,
                            company,
                            firstName,
                            lastName: ev.target.value,
                            username,
                            email,
                            address,
                            city,
                            country,
                            zipCode,
                            biography,
                            loading,
                            saving,
                            error: ''
                          })}
                        />
                      </Column>
                    </Grid>
                    <Grid className="userprofile_page__form_row">
                      <Column lg={16} md={4} sm={4}>
                        <TextInput
                          id="address"
                          labelText="Indirizzo"
                          value={address ? address : ""}
                          onChange={ev => setUserProfileForm({
                            id,
                            company,
                            firstName,
                            lastName,
                            username,
                            email,
                            address: ev.target.value,
                            city,
                            country,
                            zipCode,
                            biography,
                            loading,
                            saving,
                            error: ''
                          })}
                        />
                      </Column>
                    </Grid>
                    <Grid className="userprofile_page__form_row">
                      <Column lg={6} md={4} sm={4}>
                        <TextInput
                          id="city"
                          labelText="Città"
                          value={city ? city : ""}
                          onChange={ev => setUserProfileForm({
                            id,
                            company,
                            firstName,
                            lastName,
                            username,
                            email,
                            address,
                            city: ev.target.value,
                            country,
                            zipCode,
                            biography,
                            loading,
                            saving,
                            error: ''
                          })}
                        />
                      </Column>
                      <Column lg={5} md={4} sm={4}>
                        <TextInput
                          id="state"
                          labelText="Stato"
                          value={country ? country : ""}
                          onChange={ev => setUserProfileForm({
                            id,
                            company,
                            firstName,
                            lastName,
                            username,
                            email,
                            address,
                            city,
                            country: ev.target.value,
                            zipCode,
                            biography,
                            loading,
                            saving,
                            error: ''
                          })}
                        />
                      </Column>
                      <Column lg={5} md={4} sm={4}>
                        <TextInput
                          id="zipcode"
                          labelText="Codice postale"
                          value={zipCode ? zipCode : ""}
                          onChange={ev => setUserProfileForm({
                            id,
                            company,
                            firstName,
                            lastName,
                            username,
                            email,
                            address,
                            city,
                            country,
                            zipCode: ev.target.value,
                            biography,
                            loading,
                            saving,
                            error: ''
                          })}
                        />
                      </Column>
                    </Grid>
                    <Grid className="userprofile_page__form_row">
                      <Column lg={16} md={4} sm={4}>
                        <TextArea
                          id="aboutme"
                          labelText="Biografia"
                          value={biography ? biography : ""}
                          onChange={ev => setUserProfileForm({
                            id,
                            company,
                            firstName,
                            lastName,
                            username,
                            email,
                            address,
                            city,
                            country,
                            zipCode,
                            biography: ev.target.value,
                            loading,
                            saving,
                            error: ''
                          })}
                        />
                      </Column>
                    </Grid>
                  </Column>
                </Grid>
                <Grid>
                  <Column>
                    <Button type="submit">Salva</Button>
                  </Column>
                </Grid>
              </Tile>
            </Column>
          </Grid>
        </Form>
        <Grid>
          <Column lg={3} md={4} sm={4}>
          </Column>
          <Column lg={13} md={4} sm={4}>
            <Tile className="userprofile-page__card">
              <Form onSubmit={(ev) => handleChangePassword(ev)}>
                <Grid className="userprofile_page__fields">
                  <Column lg={16} md={4} sm={4}>
                    <h4 className="userprofile_page__section-title">
                      Cambia password
                    </h4>
                    <PasswordInput
                      id="old-password"
                      labelText="Password attuale"
                      style={{marginBottom: '1rem'}}/>
                    <PasswordInput
                      id="new-password"
                      labelText="Nuova password"
                      style={{marginBottom: '1rem'}}/>
                    <PasswordInput
                      id="new-password-confirm"
                      labelText="Conferma nuova password"
                      style={{marginBottom: '1rem'}}/>
                  </Column>
                </Grid>
                <Grid>
                  <Column>
                    <Button id="change-password-btn" type="submit">Cambia password</Button>
                  </Column>
                </Grid>
              </Form>
            </Tile>
          </Column>
        </Grid>
      </Column>
    </Grid>
  );
};

export default UserProfile;